import { Flex, Link, Text, Divider } from 'theme-ui';
import React from 'react';
import { AdjustmentsIcon, ClockIcon, GlobeIcon, TrashIcon } from '@heroicons/react/outline';
import { Photo } from 'tabler-icons-react';
import { CompanyUser, Company } from './types';
import { LoginAsAdmin } from './LoginAsAdmin';
import { useNavigate } from 'react-router-dom';
import { setCompanyId } from '@/store/deleteCompany';
import { setMarkCompanyId } from '@/store/markForDeletion';
import { useDispatch } from 'react-redux';

interface ActionsItemsProps extends Company {
    onAddFeatureFlag: () => void;
}

const ActionsItems: React.FC<ActionsItemsProps> = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    return (
        <React.Fragment>
            <Flex
                sx={{
                    flexDirection: 'column',
                    gap: 3,
                }}
            >
                <LoginAsAdmin companyId={props.Id} mr={3} variant="menu" />
                <Link
                    variant="menu"
                    target="_blank"
                    href={`https://${props?.SitePath}.${process.env.REACT_APP_COMPANY_HOMEPAGE_DOMAIN_NAME}`}
                >
                    <GlobeIcon width={16} height={16} />
                    <Text>Navigate to website</Text>
                </Link>
                <Link
                    variant="menu"
                    target="_blank"
                    href={`/clients/${props.Id}`}
                    onClick={(evt) => {
                        evt.preventDefault();
                        navigate(`/clients/${props.Id}`);
                    }}
                >
                    <Photo width={16} height={16} />
                    <Text>Open details</Text>
                </Link>
                <Link
                    variant="menu"
                    href="#"
                    onClick={(evt) => {
                        evt.preventDefault();
                        props.onAddFeatureFlag();
                    }}
                >
                    <AdjustmentsIcon width={16} height={16} />
                    <Text>Feature flags</Text>
                </Link>
                <Link
                    variant="menu"
                    href={`#`}
                    color="danger"
                    onClick={(evt) => {
                        evt.preventDefault();
                        dispatch(
                            setMarkCompanyId({
                                companyId: props.Id,
                                inactivityNotificationDate: props.InactivityNotificationDate,
                            })
                        );
                    }}
                >
                    <ClockIcon width={16} height={16} color="danger" />
                    <Text color="danger">Mark for deletion</Text>
                </Link>
                <Link
                    variant="menu"
                    href={`#`}
                    color="danger"
                    onClick={(evt) => {
                        evt.preventDefault();
                        dispatch(setCompanyId(props.Id));
                    }}
                >
                    <TrashIcon width={16} height={16} color="danger" />
                    <Text color="danger">Delete</Text>
                </Link>
            </Flex>
            <Divider variant="styles.hr.menu" />
        </React.Fragment>
    );
};

export default ActionsItems;
